export default __webpack_public_path__ + "static/media/Univers-Condensed-Bold.66603bfd.otf";